/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';

import { CREATE_METRO2_USER_COMMENT, DELETE_METRO2_USER_COMMENT, UPDATE_METRO2_USER_COMMENT } from 'Apollo/Mutations/Rules/Metro2';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_USER_COMMENTS_FOR_METRO2 } from 'Apollo/Queries/Rules/Metro2Results';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery,
} from '@apollo/client';

import Metro2Comment from '../components/Metro2Comment';

const Metro2Comments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);

    const [metro2Comment, setMETRO2Comment] = useState('');
    const [metro2Show, setShow] = useState(false);
    const [metro2Target, setTarget] = useState(null);
    const [metro2Edit, setEdit] = useState(false);
    const [metro2SelectedComment, setMETRO2SelectedComment] = useState('');
    const [metro2SelectedCommentID, setSelectedCommentID] = useState('');
    const [metro2SelectedIndex, setSelectedIndex] = useState(null);

    /* Apollo query to fetch user information */
    const getMETRO2User = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, error, data: { getUserCommentsForMetro2 = {} } = {} }] = useLazyQuery(GET_USER_COMMENTS_FOR_METRO2, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_METRO2_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                commentText: metro2Comment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_METRO2_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_METRO2_USER_COMMENT);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    /* Comment option handler */
    const handleMETRO2Click = (index, text, commentId, event) => {
        setShow(!metro2Show);
        setSelectedIndex(index);
        setMETRO2SelectedComment(text);
        setSelectedCommentID(commentId);
        setTarget(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addMETRO2Comment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setMETRO2Comment('');
    };

    /* Toggled edit value */
    const onMetro2EditClick = () => {
        setEdit(!metro2Edit);
    };

    /* Cancal button handler */
    const onMETRO2CancelClick = () => {
        setEdit(!metro2Edit);
        setSelectedIndex(null);
        setMETRO2SelectedComment('');
        setShow(!metro2Show);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onMETRO2ClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: metro2SelectedComment,
                    commentId: metro2SelectedCommentID,
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setEdit(!metro2Edit);
        setSelectedIndex(null);
        setMETRO2SelectedComment('');
        setShow(!metro2Show);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests result */
    const onMETRO2ClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: metro2SelectedCommentID,
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setSelectedIndex(null);
        setMETRO2SelectedComment('');
        setShow(!metro2Show);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    if (error) {
        return <div>Error</div>;
    }
    return (
        <Metro2Comment
            getMETRO2User={getMETRO2User}
            metro2Comment={metro2Comment}
            setMETRO2Comment={setMETRO2Comment}
            commentLoading={commentLoading}
            addMETRO2Comment={addMETRO2Comment}
            loading={loading}
            getUserCommentsForMetro2={getUserCommentsForMetro2}
            handleMETRO2Click={handleMETRO2Click}
            onMetro2EditClick={onMetro2EditClick}
            onMETRO2ClickDelete={onMETRO2ClickDelete}
            onMETRO2CancelClick={onMETRO2CancelClick}
            onMETRO2ClickSave={onMETRO2ClickSave}
            metro2Show={metro2Show}
            metro2Target={metro2Target}
            metro2Edit={metro2Edit}
            metro2SelectedComment={metro2SelectedComment}
            metro2SelectedCommentID={metro2SelectedCommentID}
            setMETRO2SelectedComment={setMETRO2SelectedComment}
            metro2SelectedIndex={metro2SelectedIndex}
        />
    );
};

export default Metro2Comments;
